<template>
  <section role="main">
    <form
      @submit.prevent="savePatientInfo"
      class="mt-5 mr-2 ml-2 justify-content-md-center"
    >
      <div class="col">
        <section class="card">
          <header class="card-header">
            <h2 class="card-title">Please confirm your information</h2>
          </header>
          <div class="card-body">
            <div v-if="!isLoading">
              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >First Name <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.firstName"
                    maxlength="25"
                    required
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Last Name <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.lastName"
                    maxlength="25"
                    required
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550">Middle Initial</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.mi"
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550">Nickname</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.nickName"
                    maxlength="25"
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550">Suffix</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.suffix"
                    maxlength="10"
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Email <span style="color: red">*</span></label
                  >
                  <input
                    type="email"
                    class="form-control"
                    v-model="form.email"
                    required
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Address 1 <span style="color: red">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.address"
                    required
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550">Address 2</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.address2"
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >City <span style="color: red">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.city"
                    required
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >State <span style="color: red">*</span>
                  </label>
                  <select v-model="form.state" class="form-control" required>
                    <option
                      v-for="state in usStates"
                      :key="state.code"
                      :value="state.code"
                    >
                      {{ state.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Zip Code <span style="color: red">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.zip"
                    required
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Home Phone
                    <span v-show="form.cellPhone === ''" style="color: red"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.homePhone"
                    :required="form.cellPhone === ''"
                    v-mask="'(###) ###-####'"
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Mobile Phone
                    <span v-show="form.homePhone === ''" style="color: red"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.cellPhone"
                    :required="form.homePhone === ''"
                    v-mask="'(###) ###-####'"
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Date of Birth <span style="color: red">*</span></label
                  >
                  <el-date-picker
                    v-model="form.dob"
                    type="date"
                    placeholder="Select date"
                    format="MMMM dd, yyyy"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    required
                    @change="validateDOB"
                    @input="clearDOBError"
                  >
                  </el-date-picker>
                  <small v-if="dobError" class="text-danger">{{ dobError }}</small>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Gender <span style="color: red">*</span></label
                  >
                  <select class="form-control" v-model="form.sex" required>
                    <option
                      v-for="gender in genderList"
                      :value="gender.id"
                      :key="gender.value"
                    >
                      {{ gender.value }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Employment <span style="color: red">*</span></label
                  >
                  <select
                    class="form-control"
                    v-model="form.employStatID"
                    required
                  >
                    <option
                      v-for="employ in employmentList"
                      :value="employ.id"
                      :key="employ.value"
                    >
                      {{ employ.value }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Marital Status <span style="color: red">*</span></label
                  >
                  <select v-model="form.maritalStatID" class="form-control" required>
                    <option
                      v-for="marital in statusList"
                      :key="marital.value"
                      :value="marital.id"
                    >
                      {{ marital.value }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Emergency Contact <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.emerContact"
                    required
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Emergency Relation <span style="color: red">*</span></label
                  >
                  <select class="form-control" v-model="form.emerRelation" required>
                    <option value="">Select Relation</option>
                    <option
                      v-for="relation in relationList"
                      :value="relation"
                      :key="relation"
                    >
                      {{ relation }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Emergency Phone <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.emerPhone"
                    v-mask="'(###)-###-####'"
                    required
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <h5 class="h5">Is this a result of:</h5>
                  <div class="pl-2">
                    <label
                      class="label fw-500 pr-2 text-right"
                      style="width: 120px"
                      >Auto Accident:</label
                    >
                    <div class="form-check form-check-inline">
                      <input
                        type="radio"
                        class="form-check-input"
                        name="aaquestion"
                        :checked="isAutoAccident"
                        @click="isAutoAccident = true"
                      />
                      <label class="form-check-label check-inline">Yes</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        type="radio"
                        class="form-check-input"
                        name="aaquestion"
                        :checked="!isAutoAccident"
                        @click="isAutoAccident = false"
                      />
                      <label class="form-check-label">No</label>
                    </div>
                  </div>
                  <div class="pl-2">
                    <label
                      class="label fw-500 pr-2 text-right"
                      style="width: 120px"
                      >Work Injury:</label
                    >
                    <div class="form-check form-check-inline">
                      <input
                        type="radio"
                        class="form-check-input"
                        name="wiquestion"
                        :checked="isWorkInjury"
                        @click="isWorkInjury = true"
                      />
                      <label class="form-check-label check-inline">Yes</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        type="radio"
                        class="form-check-input"
                        name="wiquestion"
                        :checked="!isWorkInjury"
                        @click="isWorkInjury = false"
                      />
                      <label class="form-check-label">No</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isLoading">
              <div class="col-12">
                <content-placeholders :rounded="true" :centered="true">
                  <content-placeholders-text :lines="20" />
                </content-placeholders>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <div class="row justify-content-end">
              <div class="col-sm-9">
                <!-- <button
                  type="reset"
                  class="btn btn-default mr-2"
                  @click="previous"
                  v-if="
                    getTaskPreviousTaskType &&
                    getTaskPreviousTaskType !== getTaskCurrentTaskType
                  "
                >
                  Back
                </button> -->
                <btn-saving :is-saving="isSaving" />
              </div>
            </div>
          </footer>
        </section>
      </div>
    </form>
  </section>
</template>

<script>
// import moment from 'moment'
import api from '../../api/http-common.js'
import { mapGetters, mapActions } from 'vuex'
import btnSaving from '../button-saving.vue'
export default {
  components: {
    btnSaving
  },
  data() {
    return {
      isRequired: true,
      isLoading: true,
      isSaving: false,
      portalId: null,
      caseHistoryId: null,
      form: {
        firstName: '',
        lastName: '',
        middleInitial: '',
        nickName: '',
        suffix: '',
        email: '',
        address: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        homePhone: '',
        cellPhone: '',
        dob: '',
        sex: '',
        employment: '',
        maritalStatID: '',
        emerContact: '',
        emerRelation: '',
        emerPhone: ''
      },
      isAutoAccident: false,
      isWorkInjury: false,
      dobError: '',
      usStates: [],
      relationList: [
        'SPOUSE',
        'CHILD',
        'MOTHER',
        'FATHER',
        'BROTHER',
        'SISTER',
        'AUNT',
        'UNCLE',
        'COUSIN',
        'FRIEND',
        'OTHER'
      ],
      employmentList: [
        { id: 1, value: 'Employed' },
        { id: 2, value: 'Full Time Student' },
        { id: 3, value: 'Part Time Student' },
        { id: 4, value: 'Retired' },
        { id: 5, value: 'Other' }
      ],
      statusList: [
        { id: 1, value: 'Single' },
        { id: 2, value: 'Married' },
        { id: 3, value: 'Other' },
        { id: 4, value: 'Divorced' },
        { id: 5, value: 'Widowed' },
        { id: 6, value: 'Child' }
      ],
      genderList: [
        { id: 'M', value: 'Male' },
        { id: 'F', value: 'Female' },
        { id: 'X', value: 'Non-Binary' }
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'getProfilePatientAssociated',
      'getTaskPreviousTaskType',
      'getTaskCurrentTaskType',
      'currentPatientAssociated',
      'getTaskCode',
      'getTaskInfo'
    ]),
    TaskInfo() {
      if (this.getTaskInfo !== '') {
        return JSON.parse(this.getTaskInfo)
      } else {
        return null
      }
    }
  },
  methods: {
    ...mapActions([
      'setTaskCurrentTaskType',
      'setTaskCurrentCaseHistoryId',
      'setTaskInfo',
      'clearUrlLinkInfo'
    ]),
    toggle(val) {
      this.isAutoAccident = val
    },
    async previous() {
      // Clear URL link info when navigating back to dashboard
      await this.clearUrlLinkInfo()
      // this.setTaskCurrentTaskType(this.getTaskPreviousTaskType)
      await this.$router.push({ path: '/' })
    },
    async savePatientInfo() {
      // Validate DOB before proceeding
      if (!this.validateDOB()) {
        return
      }

      this.isSaving = true
      console.log('form>', this.form)
      await api.task.request.updatePatient(this.form)
      let result = await api.task.request.findIncompleteCaseHistory({
        facilityId: this.currentPatientAssociated.facilityID,
        patientId: this.currentPatientAssociated.patientID
      })
      if (!result.data) {
        result = await api.task.request.insertCaseHistory({
          facilityId: this.currentPatientAssociated.facilityID,
          patientId: this.currentPatientAssociated.patientID,
          aa: this.isAutoAccident
        })
        this.updateCaseHistory(result.data)
      }
      await this.setTaskCurrentCaseHistoryId(result.data)
      this.isSaving = false
      console.log(this.TaskInfo)
      if (this.TaskInfo) {
        if (this.TaskInfo.Action === 'INSINFO') {
          const taskinfo = this.TaskInfo
          if (this.TaskInfo.TaskType !== 'INS') {
            taskinfo.CurrentTaskType = this.isAutoAccident
              ? 'NphAutoAccident'
              : 'NphComplaintLocation'
          } else {
            taskinfo.CurrentTaskType = 'NphThankyou'
          }
          this.setTaskInfo(JSON.stringify(taskinfo))
          this.setTaskCurrentTaskType('NphInsurance')
        }
      } else if (this.isAutoAccident) {
        this.setTaskCurrentTaskType('NphAutoAccident')
      } else {
        this.setTaskCurrentTaskType('NphComplaintLocation')
      }
    },
    async updateCaseHistory(caseId) {
      await api.task.request.updateCaseHistory({
        facilityId: this.currentPatientAssociated.facilityID,
        id: caseId,
        aa: this.isAutoAccident,
        wc: this.isWorkInjury
      })
    },
    async getPatientInfo() {
      const patientInfo = await api.task.request.getPatient({
        facilityId: this.currentPatientAssociated.facilityID,
        patientId: this.currentPatientAssociated.patientID
      })
      console.log('patientInfo>', patientInfo)
      this.form = patientInfo.data
      this.form.facilityID = this.currentPatientAssociated.facilityID
      // NOTE: Mapping to the UpdatePatientRequest
      this.form.patientID = patientInfo.data.id
      this.form.mi = patientInfo.mi
      switch (this.getTaskCode) {
        case 'AANPH':
        case 'AACH':
          this.isAutoAccident = true
          break
      }
    },
    validateDOB() {
      this.dobError = ''

      if (!this.form.dob) {
        this.dobError = 'Date of Birth is required'
        return false
      }

      const givenDate = new Date(this.form.dob)
      const todaysDate = new Date()

      if (isNaN(givenDate.getTime())) {
        this.dobError = 'Please enter a valid Date of Birth'
        return false
      }

      if (givenDate > todaysDate) {
        this.dobError = 'Date of Birth cannot be in the future'
        return false
      }

      // Check for reasonable age (not older than 150 years)
      const age = todaysDate.getFullYear() - givenDate.getFullYear()
      if (age > 150) {
        this.dobError = 'Please enter a valid Date of Birth'
        return false
      }

      return true
    },
    clearDOBError() {
      this.dobError = ''
    },
    async getUsStates() {
      const result = await api.task.request.getUsStates()
      this.usStates = result.data
    }
  },
  async mounted() {
    try {
      this.isLoading = true
      await this.getUsStates()
      await this.getPatientInfo()
    } catch (error) {
      console.error('Error during component initialization:', error)
      this.$swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to load patient information. Please refresh the page and try again.'
      })
    } finally {
      this.isLoading = false
    }
  }
}
</script>
<style scoped>
.h5 {
  font-size: 1.1em !important;
  font-weight: 600;
  letter-spacing: normal;
  line-height: 18px;
  color: black;
}

.fw-500 {
  font-weight: 550;
}
</style>
